import { useContext } from 'react';
import PageContext from './PageContext';
import greenCircleIcon from '../../svgs/green-circle-icon.svg';
import redCircleIcon from '../../svgs/red-circle-icon.svg';
import RowEditIcon from './RowEditIcon';
import displayDateTime from '../functions/displayDateTime';
import { TableCell } from '@mui/material';

// pass row object as prop
const CompanyEntitlementsRow = ({ row, count, tableHeader, enableEdit ,stickyEnabled}) => {
    // get context variables from parent
    const {
        editEntitlementsModal, 
        setEditEntitlementsModal, 
        editEntitlementsRow, 
        setEditEntitlementsRow, 
    } = useContext(PageContext);
     
    // event handler for edit button click
    const onEditClick = () => {
        // set row to be used in modal 
        setEditEntitlementsRow(editEntitlementsRow => editEntitlementsRow = row);
        // make EditEntitlementsModal visible
        setEditEntitlementsModal(editEntitlementsModal => editEntitlementsModal = true);
    }

    // display red circle for disabled (0) status or green circle for active (1) status
    const statusIcon = (status) =>{
        if ( status == true){
            return <img src={greenCircleIcon} class='data-table-icon-left'/>
        }
        else {
            return <img src={redCircleIcon} class='data-table-icon-left'/>
        }
    }

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    return(
        <>
            {/* display all columns */}
            {tableHeader.map(el =>
                el['columnname'] == 'blank' ? 
                // icon to activate edit modal on click 
                <TableCell className={getRowClassName(el['columnorder'])}>
                    {/* show edit icon to trigger EditSubCompanyRow modal */}                      
                    <RowEditIcon enable={enableEdit} onClick={onEditClick}/>
                </TableCell>
                : el['columnname'] == 'lastupdatedtimestamp' ?
                    <TableCell className={getRowClassName(el['columnorder'])}>{displayDateTime(row[el['columnname']])}</TableCell>
                : el['columnname'] == 'active' ? 
                    <TableCell className={getRowClassName(el['columnorder'])}>{statusIcon(row[el['columnname']])}</TableCell>
                :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>
            )}            
        </>
    );
}

export default CompanyEntitlementsRow; 